import { render } from "./MarketSection.vue?vue&type=template&id=cb360898&scoped=true"
import script from "./MarketSection.vue?vue&type=script&lang=js"
export * from "./MarketSection.vue?vue&type=script&lang=js"

import "./MarketSection.vue?vue&type=style&index=0&id=cb360898&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb360898"]])

export default __exports__